import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import ChatbotContent from "app/containers/Chatbot/ChatbotContent";

interface SampleWeeklyCheckInChatProps {
  onClose?: () => void;
}

const SampleWeeklyCheckInChat: React.FC<SampleWeeklyCheckInChatProps> = ({
  onClose,
}) => {
  return (
    <>
      <div
        className="warning-banner blue row-gap-16px align-items-center"
        style={{ maxWidth: "none" }}
      >
        <FontAwesomeIcon icon={["far", "info-circle"]} />
        <p>
          You are currently <b>previewing</b> the Manager Check-in chat.
          Visibility banners shown below are a preview of an actual check-in
          chat. <b>Your responses will not be saved.</b>
        </p>
      </div>
      <Card className="chatbot-card in-modal">
        <div className="chatbot-header">
          <h2>Manager Check-in</h2>
        </div>
        <ChatbotContent
          closeChatbot={() => {
            onClose?.();
          }}
        />
      </Card>
    </>
  );
};

export default SampleWeeklyCheckInChat;
